import { AnalyticsEvent, AnalyticsProvider, PageViewEvent } from '../../types/analytics.types';
import { ConfigService } from '@/configuration/services/configService';
import { createMatomoTracker, IMatomoTracker } from './matomoTracker';

export class MatomoAnalyticsProvider implements AnalyticsProvider {
    public readonly name = 'Matomo';
    private instance: IMatomoTracker | null = null;

    constructor() {
        const matomoConfig = ConfigService.get().application.analytics?.matomo;
        if (matomoConfig?.enabled) this.instance = createMatomoTracker(matomoConfig);
    }

    trackPageView(event: PageViewEvent): void {
        this.instance?.trackPageView(event);
    }

    trackEvent(event: AnalyticsEvent): void {
        this.instance?.trackEvent(event);
    }

    deleteCustomDimensions(ids: number[]): void {
        if (!this.instance) return;

        ids.forEach((id) => {
            this.instance?.pushInstruction('deleteCustomDimension', id);
        });
    }

    setUserId(userId: string): void {
        if (!this.instance) return;

        this.instance.pushInstruction('setUserId', userId);
    }

    resetUserId(): void {
        if (!this.instance) return;

        this.instance.pushInstruction('resetUserId');
        this.instance.pushInstruction('appendToTrackingUrl', 'new_visit=1');
        this.instance.trackPageView({
            documentTitle: document.title,
            href: window.location.href,
        });
        this.instance.pushInstruction('appendToTrackingUrl', '');
    }

    isEnabled(): boolean {
        return this.instance !== null;
    }
}
